/* eslint-disable */


import { Link, useLocation, useNavigate } from "react-router-dom";
import ImageWithBasePath from "../../imageWithBasePath";
import React, { useEffect, useState } from "react";
import { SidebarData } from "./sidebarData";
import { useDispatch, useSelector } from "react-redux";
import { all_routes } from "../../../feature-module/router/all_routes";
import { setExpandMenu } from "../../redux/sidebarSlice";
import { updateTheme } from "../../redux/themeSlice";


const Sidebar = () => {
  const routes = all_routes;
  const Location = useLocation();
  const [subOpen, setSubopen] = useState<any>("");
  const [subsidebar, setSubsidebar] = useState("");
  const dispatch = useDispatch();


  const toggleSidebar = (title: any) => {
    localStorage.setItem("menuOpened", title);
    if (title === subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };


  const toggleSubsidebar = (subitem: any) => {
    if (subitem === subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };


  const handleClick = (label: any) => {
    toggleSidebar(label);
  };


  const navigate = useNavigate();
  const themeSettings = useSelector((state: any) => state.theme.themeSettings);


  const handleMiniSidebar = () => {
    const rootElement = document.documentElement;
    const isMini = rootElement.getAttribute("data-layout") === "mini";
    const updatedLayout = isMini ? "default" : "mini";
    dispatch(
      updateTheme({
        "data-layout": updatedLayout,
      })
    );
    if (isMini) {
      rootElement.classList.remove("mini-sidebar");
    } else {
      rootElement.classList.add("mini-sidebar");
    }
  };
  const onMouseEnter = () => {
    dispatch(setExpandMenu(true));
  };
  const onMouseLeave = () => {
    dispatch(setExpandMenu(false));
  };


  const handleLayoutClick = (layout: string) => {
    const layoutSettings: any = {
      "data-layout": "default",
      dir: "ltr",
    };


    switch (layout) {
      case "Default":
        layoutSettings["data-layout"] = "default";
        break;
      case "Single":
        layoutSettings["data-layout"] = "single";
        break;
      case "Mini":
        layoutSettings["data-layout"] = "mini";
        break;
      case "Transparent":
        layoutSettings["data-layout"] = "transparent";
        break;
      case "Without Header":
        layoutSettings["data-layout"] = "without-header";
        break;
      case "RTL":
        layoutSettings.dir = "rtl";
        break;
      case "Dark":
        layoutSettings["data-bs-theme"] = "dark";
        break;
      default:
        break;
    }
    dispatch(updateTheme(layoutSettings));
    navigate("/admin-dashboard");
  };
  useEffect(() => {
    const rootElement:any = document.documentElement;
    Object.entries(themeSettings).forEach(([key, value]) => {
      rootElement.setAttribute(key, value);
    });
    if (themeSettings["data-layout"] === "mini") {
      rootElement.classList.add("mini-sidebar");
    } else {
      rootElement.classList.remove("mini-sidebar");
    }
  }, [themeSettings]);


  return (
    <>
      {/* Sidenav Menu Start */}
      <div
        className="two-col-sidebar"
        id="two-col-sidebar"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <div className="twocol-mini">
          {/* Add */}
          <div className="dropdown">
            <Link
              className="btn btn-primary bg-gradient btn-sm btn-icon rounded-circle d-flex align-items-center justify-content-center"
              data-bs-toggle="dropdown"
              to="#"
              role="button"
              data-bs-display="static"
              data-bs-reference="parent"
            >
              <i className="isax isax-add" />
            </Link>
            <ul className="dropdown-menu dropdown-menu-start">
              <li>
                <Link
                  to={all_routes.addInvoice}
                  className="dropdown-item d-flex align-items-center"
                >
                  <i className="isax isax-document-text-1 me-2" />
                  Invoice
                </Link>
              </li>
              <li>
                <Link
                  to={all_routes.expenses}
                  className="dropdown-item d-flex align-items-center"
                >
                  <i className="isax isax-money-send me-2" />
                  Expense
                </Link>
              </li>
              <li>
                <Link
                  to={all_routes.addCreditNotes}
                  className="dropdown-item d-flex align-items-center"
                >
                  <i className="isax isax-money-add me-2" />
                  Credit Notes
                </Link>
              </li>
              <li>
                <Link
                  to={all_routes.addDebitNotes}
                  className="dropdown-item d-flex align-items-center"
                >
                  <i className="isax isax-money-recive me-2" />
                  Debit Notes
                </Link>
              </li>
              <li>
                <Link
                  to={all_routes.purchaseOrders}
                  className="dropdown-item d-flex align-items-center"
                >
                  <i className="isax isax-document me-2" />
                  Purchase Order
                </Link>
              </li>
              <li>
                <Link
                  to={all_routes.addquotations}
                  className="dropdown-item d-flex align-items-center"
                >
                  <i className="isax isax-document-download me-2" />
                  Quotation
                </Link>
              </li>
              <li>
                <Link
                  to={all_routes.deliveryChallans}
                  className="dropdown-item d-flex align-items-center"
                >
                  <i className="isax isax-document-forward me-2" />
                  Delivery Challan
                </Link>
              </li>
            </ul>
          </div>
          {/* /Add */}
          <ul className="menu-list">
            <li>
              <Link
                to={all_routes.accountSettings}
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                data-bs-title="Settings"
              >
                <i className="isax isax-setting-25" />
              </Link>
            </li>
            <li>
              <Link
                to="#"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                data-bs-title="Documentation"
              >
                <i className="isax isax-document-normal4" />
              </Link>
            </li>
            <li>
              <Link
                to="#"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                data-bs-title="Changelog"
              >
                <i className="isax isax-cloud-change5" />
              </Link>
            </li>
            <li>
              <Link to={all_routes.login}>
                <i className="isax isax-login-15" />
              </Link>
            </li>
          </ul>
        </div>
        <div className="sidebar" id="sidebar-two">
          {/* Start Logo */}
          <div className="sidebar-logo">
            <Link to={routes.adminDashboard} className="logo logo-normal">
              <ImageWithBasePath src="assets/img/logo.png" alt="Logo" />
            </Link>
            <Link to={routes.adminDashboard} className="logo-small">
              <ImageWithBasePath src="assets/img/logo-small.png" alt="Logo" />
            </Link>
            <Link to={routes.adminDashboard} className="dark-logo">
              <ImageWithBasePath src="assets/img/logo.png" alt="Logo" />
            </Link>
            <Link to={routes.adminDashboard} className="dark-small">
              <ImageWithBasePath
                src="assets/img/logo-small.png"
                alt="Logo"
              />
            </Link>
            {/* Sidebar Hover Menu Toggle Button */}
            <Link id="toggle_btn" to="#" onClick={handleMiniSidebar}>
              <i className="isax isax-menu-1" />
            </Link>
          </div>
          {/* End Logo */}
          {/* Search */}
          <div className="sidebar-search">
            <div className="input-icon-end position-relative">
              <input
                type="text"
                className="form-control"
                placeholder="Search"
              />
              <span className="input-icon-addon">
                <i className="isax isax-search-normal" />
              </span>
            </div>
          </div>
          {/* /Search */}
          {/*- Sidenav Menu */}
          <div data-simplebar="">
            <div className="sidebar-inner">
              <div id="sidebar-menu" className="sidebar-menu">
                <ul>
                  {SidebarData?.map((mainLabel, index) => (
                    <React.Fragment key={`main-${index}`}>
                      <li className="menu-title">
                        <span>{mainLabel?.tittle}</span>
                      </li>
                      <li>
                        <ul>
                          {mainLabel?.submenuItems?.map((title: any, i) => {
                            let link_array: any = [];
                            if ("submenuItems" in title) {
                              title.submenuItems?.forEach((link: any) => {
                                link_array.push(link?.link);
                                if (link?.submenu && "submenuItems" in link) {
                                  link.submenuItems?.forEach((item: any) => {
                                    link_array.push(item?.link);
                                  });
                                }
                              });
                            }
                            title.links = link_array;

                            return (
                              <li className="submenu" key={`title-${i}`}>
                                <Link
                                  to={title?.submenu ? "#" : title?.link}
                                  onClick={() => {
                                    handleClick(title?.label);

                                    if (mainLabel?.tittle === "Layout") {
                                      handleLayoutClick(title?.label);
                                    }
                                  }}
                                  className={`${
                                    subOpen === title?.label ||
                                    title?.links?.includes(Location.pathname)
                                      ? "subdrop"
                                      : ""
                                  } ${
                                    title?.links?.includes(Location.pathname) ||
                                    title?.link === Location.pathname
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <i className={`isax isax-${title.icon}`}></i>
                                  <span>{title?.label}</span>
                                  {(title?.submenu ||
                                    title?.customSubmenuTwo) && (
                                    <span className="menu-arrow"></span>
                                  )}
                                 {title?.submenu === false && title?.version === 'v2.0.7' && (
  <span className="badge bg-primary ms-2 badge-sm text-white fs-12 fw-medium">v2.0.7</span>
)}
                                </Link>
                               
                                {title?.submenu !== false && (
                                  <ul
                                    style={{
                                      display:
                                        subOpen === title?.label ||
                                        title?.links?.includes(
                                          Location.pathname
                                        )
                                          ? "block"
                                          : "none",
                                    }}
                                  >
                                    {title?.submenuItems?.map(
                                      (item: any, j: any) => {
                                        const isSubActive =
                                          item?.submenuItems
                                            ?.map((link: any) => link?.link)
                                            .includes(Location.pathname) ||
                                          item?.link === Location.pathname;

                                        return (
                                          <li
                                            className={`${
                                              item?.submenuItems
                                                ? "submenu submenu-two"
                                                : ""
                                            } `}
                                            key={`item-${j}`}
                                          >
                                            <Link
                                              to={
                                                item?.submenu ? "#" : item?.link
                                              }
                                              className={`${
                                                isSubActive
                                                  ? "active subdrop"
                                                  : ""
                                              } ${
                                                subsidebar === item?.label
                                                  ? "subdrop"
                                                  : ""
                                              }`}
                                              onClick={() => {
                                                toggleSubsidebar(item?.label);
                                              }}
                                            >
                                              {item?.label}
                                              {(item?.submenu ||
                                                item?.customSubmenuTwo) && (
                                                <span className="menu-arrow"></span>
                                              )}
                                            </Link>
                                            {item?.submenuItems ? (
                                              <ul
                                                style={{
                                                  display:
                                                    subsidebar === item?.label
                                                      ? "block"
                                                      : "none",
                                                }}
                                              >
                                                {item?.submenuItems?.map(
                                                  (items: any, k: any) => {
                                                    const isSubSubActive =
                                                      items?.submenuItems
                                                        ?.map(
                                                          (link: any) =>
                                                            link.link
                                                        )
                                                        .includes(
                                                          Location.pathname
                                                        ) ||
                                                      items?.link ===
                                                        Location.pathname;

                                                    return (
                                                      <li
                                                        key={`submenu-item-${k}`}
                                                      >
                                                        <Link
                                                          to={
                                                            items?.submenu
                                                              ? "#"
                                                              : items?.link
                                                          }
                                                          className={`${
                                                            isSubSubActive
                                                              ? "active"
                                                              : ""
                                                          }`}
                                                        >
                                                          {items?.label}
                                                        </Link>
                                                      </li>
                                                    );
                                                  }
                                                )}
                                              </ul>
                                            ) : null}
                                          </li>
                                        );
                                      }
                                    )}
                                  </ul>
                                )}
                              </li>
                            );
                          })}
                        </ul>
                      </li>
                    </React.Fragment>
                  ))}
                </ul>
                <div className="sidebar-footer">
                  <div className="trial-item bg-white text-center border">
                    <div className="bg-light p-3 text-center">
                      <ImageWithBasePath
                        src="assets/img/icons/upgrade.svg"
                        alt="img"
                      />
                    </div>
                    <div className="p-2">
                      <h6 className="fs-14 fw-semibold mb-1">
                        Upgrade to More
                      </h6>
                      <p className="fs-13 mb-2">
                        Subscribe to get more with Premium Features
                      </p>
                      <Link
                        to={all_routes.plansBillings}
                        className="btn btn-sm btn-primary w-100 d-flex align-items-center justify-content-center"
                      >
                        <i className="isax isax-crown5 me-1" />
                        Upgrade
                      </Link>
                    </div>
                    <Link to="#" className="close-icon">
                      <i className="fa-solid fa-x" />
                    </Link>
                  </div>
                  <ul className="menu-list">
                    <li>
                      <Link
                        to={all_routes.accountSettings}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-title="Settings"
                      >
                        <i className="isax isax-setting-25" />
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-title="Documentation"
                      >
                        <i className="isax isax-document-normal4" />
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-title="Changelog"
                      >
                        <i className="isax isax-cloud-change5" />
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={all_routes.login}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-title="Login"
                      >
                        <i className="isax isax-login-15" />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Sidenav Menu End */}
    </>
  );
};


export default Sidebar;





